import request from '@/plugin/axios'
export function GetUserInfo() {
    return request({
        url: '/MobileApis/MemberHandler.ashx?action=GetUserInfo',
        method: 'POST'
    })
}
